/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Warning_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} warning" |
* | "other" | "{count} warnings" |
*
* @param {Warning_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const warning_count = /** @type {((inputs: Warning_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} warning`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} warnings`);
		return /** @type {LocalizedString} */ ("warning_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} warning`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} warnings`);
		return /** @type {LocalizedString} */ ("warning_count");
	}
});